<template>
  <div :class="$style.item">
    <div :class="[$style.title]" v-if="title">{{ title }}</div>
    <div :class="$style.content">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

@Component({
  components: {},
})
export default class ListItem extends Vue {
  @Prop()
  public title!: string;
}
</script>

<style lang="scss" module>
.item {
  padding: 1.25rem 1.5rem;
  display: flex;
  border-bottom: 1px solid $grey-border;

  &:hover {
    cursor: pointer;
    background: #f7fbff;
  }

  &:last-child {
    border-bottom: none;
  }

  .title {
    width: 10%;
    text-overflow: ellipsis;
    color: $grey-3;
    font-weight: 500;
  }

  .content {
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
